/**
 * Common sagas
 * @format
 */

function* commonSagas(): Saga<void> {}

export { commonSagas };
